import { Component, OnInit } from '@angular/core';

import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';

@Component({
    selector: 'app-organization-inboxes',
    templateUrl: './organization-inboxes.component.html',
    standalone: false
})
export class OrganizationInboxesComponent
  extends BasePageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'inboxes';
  pageId: string = 'app-organization-inboxes';

  getTableDataApiMethodName: string = 'inboxesGetInboxesWithPagination';
  pageTitle: string = 'pages.inboxes.organizationInboxesTitle';
}
